
import { defineComponent, onMounted, reactive } from "vue";
import ErrorList from "@/components/commonDesign/ErrorList.vue";
import { ethitransService } from "@/services/EthitransService";
import { common } from "@/common/services/Common";

export default defineComponent({
  name: "RenameDocumentModal",
  props: {
    showModal: Boolean,
    rename: String,
    fileId: String,
    folderId: String,
  },
  components: {
    ErrorList,
  },
  setup(props, { emit }) {
    // const router = useRouter();
    const state = reactive({
      data: {
        folderRename: "" as any,
        folderList: [] as any,
        folderTitle: "folder",
        folderHeading: "No folders created",
      },
      ui: {
        error: {
          hasError: false,
          errorList: {
            rename: [] as any,
          },
        },
        isLoading: {
          getFolderList: false,
        },
        isPostLoading: {
          renameFolder: false,
        },
      },
    });
    function closeModal(data: any) {
      emit("rename", data);
      $("#renameFileModal").modal("hide");
    }
    function renameFolder() {
      state.ui.error.errorList.rename = [];
      state.ui.error.hasError = false;
      if (
       state.ui.error.errorList.rename.length != 0 ||
        state.ui.error.hasError ||
        state.ui.isPostLoading.renameFolder
      )
        return false;
      const payLoad = {
        // eslint-disable-next-line @typescript-eslint/camelcase
        folder_id: props.folderId,
        name: state.data.folderRename
      };
      state.ui.isPostLoading.renameFolder = true;
      ethitransService
        .folderRename(payLoad)
        .then((res: any) => {
          console.log("Project List Response Check:>>> ", res.data.data);
          closeModal(true)
        })
        .catch((error: any) => {
          // console.log(error);
          common
            .sdCatchErr(error,state.ui.error.errorList.rename)
            .then((res: any) => {
              state.ui.error.hasError = true;
              for (const [key, value] of Object.entries(res)) {
                if (Array.isArray(value)) {
                 state.ui.error.errorList.rename.push(value[0]);
                }
              }
            });
        })
        .finally(() => {
          state.ui.isPostLoading.renameFolder = false;
        });
    }
    function renameFile() {
      state.ui.error.errorList.rename = [];
      state.ui.error.hasError = false;
      if (
       state.ui.error.errorList.rename.length != 0 ||
        state.ui.error.hasError ||
        state.ui.isPostLoading.renameFolder
      )
        return false;
      const payLoad = {
        // eslint-disable-next-line @typescript-eslint/camelcase
        file_id: props.fileId,
        filename: state.data.folderRename
      };
      state.ui.isPostLoading.renameFolder = true;
      ethitransService
        .fileRename(payLoad)
        .then((res: any) => {
          console.log("Project List Response Check:>>> ", res.data.data);
          closeModal(res.data.data)

        })
        .catch((error: any) => {
          // console.log(error);
          common
            .sdCatchErr(error,state.ui.error.errorList.rename)
            .then((res: any) => {
              state.ui.error.hasError = true;
              for (const [key, value] of Object.entries(res)) {
                if (Array.isArray(value)) {
                 state.ui.error.errorList.rename.push(value[0]);
                }
              }
            });
        })
        .finally(() => {
          state.ui.isPostLoading.renameFolder = false;
        });
    }
    function renameSelected() {
    if(props.folderId){
      renameFolder()
    }
    if(props.fileId) {
      console.log("FILE ID")
      renameFile()
    }
    }
    onMounted(() => {
      if (props.showModal) {
        $("#renameFileModal").modal("show");
      }
      state.data.folderRename = props.rename
      if(props.fileId){
        console.log("FILE")
      }
      if(props.folderId){
        console.log("FOLER")
      }
      //   getFolderList();
    });

    return {
      state,
      closeModal,
      renameSelected,renameFolder,renameFile,
    };
  },
});
